import React from 'react';
import { Box, useTheme } from '@mui/material';
import { useAtomValue } from 'jotai';
import { ParentSize } from '@visx/responsive';
import BarChart from '../../../../Components/Charts/BarChart';
// import GraphsLegend from '../../../../Components/Charts/GraphsLegend';
import { themeAtom } from '../../../../Atoms';
import TooltipContent from './TooltipContent';
// import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

const BranchCountersWidget = function BranchCountersWidget({ branchCounters }) {
  const theme = useTheme();
  const currentTheme = useAtomValue(themeAtom);

  const branches = branchCounters?.map(({ name }) => name);

  const performedCallsData = branchCounters?.map((d, index) => ({
    index: index + 1,
    label: d?.name,
    [d?.name]: d?.callCount, //branch with his calls
    details: d?.details,
  }));

  const answeredCallsData = branchCounters?.map((d, index) => ({
    index: index + 1,
    label: d?.name,
    [d?.name]: d?.answeredCallCount, //branch with his answered calls
    details: d?.details,
    target: d?.target,
  }));

  return (
    <>
      {/* <Box display="flex" justifyContent="flex-end" paddingBottom="16px">
        <GraphsLegend
          flexDirection="row"
          legendData={branches}
          legendColor={theme.custom
            .generateConsistentUniqueColors(branches)
            ?.map((x) => x[currentTheme])}
        />
      </Box> */}
      <Box
        sx={{
          width: "auto",
          height: "40vh"
        }}>
        <ParentSize>
          {(parent) => (
            //parent component passes his css properties to BarChart
            (<BarChart
              width={parent.width}
              height={parent.height}
              dataToShow={[performedCallsData, answeredCallsData]}
              keys={branches}
              colors={theme.custom
                .generateConsistentUniqueColors(branches)
                ?.map((x) => x[currentTheme])}
              showTarget
              renderTargetIcon={({ x, y, target, value, index }) => {
                const size = 30;
                const reached = value >= target;

                return (
                  // <foreignObject
                  //   x={x - size / 2}
                  //   y={y - size / 2}
                  //   width={size}
                  //   height={size}
                  // >
                  //   {reached ? (
                  //     <CheckCircleRoundedIcon
                  //       color="success"
                  //       sx={{ fontSize: size }}
                  //     />
                  //   ) : (
                  //     <CancelRoundedIcon
                  //       color="error"
                  //       sx={{ fontSize: size }}
                  //     />
                  //   )}
                  // </foreignObject>
                  <text
                    key={`target-branch-icon-${index}`}
                    x={x - size / 2}
                    y={y + size / 2}
                    textAnchor="middle"
                    fontSize={size}
                    fontWeight="bold"
                    fill={
                      reached
                        ? theme.palette.success.main
                        : theme.palette.error.main
                    }
                  >
                    {reached ? '✓' : '✗'}
                  </text>
                );
              }}
              TooltipContent={TooltipContent}
            />)
          )}
        </ParentSize>
      </Box>
    </>
  );
};

export default BranchCountersWidget;
